const Educationdata
=[
    {
        id : "1",
        schemeName: "Scheme for Higher Education youth in Apprenticehip and skills (SHREYAS)",
        discription:"The Ministry of Human Resources Development has launched the Scheme for Higher Education Youth in Apprenticeship and Skills (SHREYAS) for providing industry apprenticeship opportunities to the general graduates exiting in April 2019 through the National Apprenticeship Promotional Scheme (NAPS)",
        launchDate: "27 February 2019",
        AnualFund: "12345"

    },
   {id : "2",
    schemeName: "National Educational Alliance For Technology (NEAT) Scheme",
    discription:"Ministry of HRD announces National Educational Alliance for Technology (NEAT) Scheme for using better technology for better learning outcomes in Higher Education.",
    launchDate: "September  2019",
    AnualFund: "12345"},
   

    {id : "3",
    schemeName: "III.	Prime Minister’s Research Fellow Scheme",
    discription:"The institutes which can offer PMRF include all the IITs, all the IISERs, Indian Institute of Science, Bengaluru and some of the top Central Universities/NITs that offer science and/or technology degrees.",
    launchDate: "2018 Year",
    AnualFund: "12345"},
   
    {
    id : "4",
        schemeName: "IMPRESS Scheme",
        discription:"The Government of India, in August 2018, had sanctioned the scheme “Impactful Policy Research in Social Sciences (IMPRESS)” at a total cost of Rs. 414 Cr for implementation up to 31.03.2021",
        launchDate: "August 2018",
        AnualFund: "12345"
    },
   { id : "5",
    schemeName: "Scheme for Promotion of academic and Research Collaboration (SPARC)",
    discription:"The scheme aims at improving the research ecosystem of India’s higher educational institutions by facilitating academic and research collaborations between Indian Institutions and the best institutions in the world.",
    launchDate: "August 2018",  AnualFund: "12345"},
   

 {   id : "6",
    schemeName: "Samagra Shiksha Scheme",
    discription:"Samagra Shiksha is an overarching programme for the school education sector extending from pre-school to class 12.",
    launchDate: "Year  2018",
    AnualFund: "12345"
},
{   id : "7",
schemeName: "Ek Bharat Shreshtha Bharat",
discription:"Ek Bharat Shreshtha Bharat” was announced by Hon’ble Prime Minister on 31st October, 2015 on the occasion of the 140th birth anniversary of Sardar Vallabhbhai Patel.",
launchDate: "31 October 2015",
AnualFund: "12345"},


{   id : "8",
schemeName: "GIAN Program",
discription:"Global Initiative of Academic Networks (GIAN) in Higher Education was launched in 2015.It is a program of Ministry of Human Resource and Development",
launchDate: "Year  2015",
AnualFund: "12345"},


{   id : "9",
schemeName: "Impacting Reasearch ,Innovation and Technology (IMPRINT)",
discription:"‘IMPRINT India’, a pan-IIT and IISc joint initiative to develop a roadmap for research to solve major engineering and technology challenges in ten technology domains relevant to India was launched on November 5, 2015.",
launchDate: " 5 November  2015",
AnualFund: "12345"},


{   id : "10",
schemeName: "Jigyasa – Student Scientist connect programme",
discription: "Council of Scientific and Industrial Research (CSIR), has joined hands with Kendriya Vidyalaya Sangathan (KVS) to implement this programme.",
launchDate: "7 July 2017",
AnualFund: "12345"
}

]
export default Educationdata;